<!-- if you're not using typescript, remove lang="ts" attribute from the script tag -->
<script module lang="ts">
	import { fade } from 'svelte/transition';

	// for passing focus on to the next Modal in the queue.
	// A module context level object is shared among all its component instances. [Read More Here](https://svelte.dev/tutorial/sharing-code)
	const modalList: HTMLElement[] = [];
</script>

<script lang="ts">
	let { header = null, content, footer = null, onModalClose, onModalEnter = () => {} } = $props();

	function keydown(e: KeyboardEvent) {
		e.stopPropagation();
		if (e.key === 'Escape') {
			onModalClose();
		}
		if (e.key === 'Enter') {
			onModalEnter();
		}
	}

	function transitionend(e: TransitionEvent) {
		const node = e.target as HTMLElement;
		node.focus();
	}

	function modalAction(node: HTMLElement) {
		const returnFn: HTMLElement[] = [];
		// for accessibility
		/* Would prevent the body from being scrollable
        if (document.body.style.overflow !== "hidden") {
            const original = document.body.style.overflow;
            document.body.style.overflow = "hidden";
            returnFn.push(() => {
                document.body.style.overflow = original;
            });
        }
        */

		node.addEventListener('keydown', keydown);
		node.addEventListener('transitionend', transitionend);
		node.focus();
		modalList.push(node);
		//@ts-ignore
		returnFn.push(() => {
			node.removeEventListener('keydown', keydown);
			node.removeEventListener('transitionend', transitionend);
			modalList.pop();
			// Optional chaining to guard against empty array.
			modalList[modalList.length - 1]?.focus();
		});
		return {
			//@ts-ignore
			destroy: () => returnFn.forEach((fn) => fn())
		};
	}
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<div class="modal" use:modalAction tabindex="0" in:fade out:fade>
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<!-- svelte-ignore a11y_no_static_element_interactions -->
	<div class="backdrop" onclick={onModalClose}></div>

	<div class="relative content-wrapper">
		<div class="pt-8 grid grid-rows-[auto_1fr_auto]" style="max-height: 100%;">
			{#if header}{@render header()}{:else}
				<!-- fallback -->
				<div>
					<h1>Your Modal Heading Goes Here...</h1>
				</div>
			{/if}

			<div class="px-8 py-4 overflow-y-auto">
				{@render content?.()}
			</div>

			{#if footer}
				<div class="bg p-4">
					{@render footer?.()}
				</div>
			{/if}
		</div>
	</div>
</div>

<style>
	div.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		display: flex;
		justify-content: center;
		z-index: 90;
	}

	div.modal:focus {
		outline: none;
	}

	div.backdrop {
		background-color: #11213d60;
		position: fixed;
		width: 100%;
		height: 100vh;
	}

	@media (min-width: 600px) {
		div.content-wrapper {
			margin-top: 4em;
			margin-bottom: 4em;
			min-width: 560px;
			max-height: 90svh;
			max-width: 90svw;
		}
	}

	@media (max-width: 600px) {
		div.content-wrapper {
			margin-top: 2em;
			max-height: 90svh;
		}
	}

	div.content-wrapper :global {
		z-index: 100;
		overflow-y: auto;
		border-radius: 0.5rem;
		--tw-bg-opacity: 1;
		background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}

	div.content-wrapper :global:where(.dark, .dark *) {
		--tw-bg-opacity: 1;
		background-color: rgb(78 78 78 / var(--tw-bg-opacity, 1));
}
</style>
